import styleInject from './../external/.pnpm/style-inject@0.3.0/external/style-inject/dist/style-inject.es.js';

var css_248z = "";
var typography = {"fontWeightBold":"700","fontWeightLight":"300","fontWeightMedium":"500","fontWeightRegular":"400"};
styleInject(css_248z);

export { typography as default };
